import React from 'react';

const MobileContainerFull = props => {
  return <div className="br-xs full" {...props} />;
};

export default MobileContainerFull;
